import { deepMix } from '@antv/util';
import { inferredColumn, constant } from './utils/helper';
/**
 * Add zero constant encode for y1 channel.
 */
export var MaybeZeroY1 = function MaybeZeroY1() {
  return function (I, mark) {
    var encode = mark.encode;
    var y1 = encode.y1;
    if (y1 !== undefined) return [I, mark];
    return [I, deepMix({}, mark, {
      encode: {
        y1: inferredColumn(constant(I, 0))
      }
    })];
  };
};
MaybeZeroY1.props = {};